const CARDS = [
  {
    title: '国产剧王炸合集',
    desc: '《星辰大海》《长相思》《庆余年》等口碑国产剧全集，4K蓝光画质免费在线观看，每日更新最新剧集。',
    tag: '热门推荐',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Chinese%20historical%20drama%20scene%20with%20warm%20golden%20palace%20lighting%2C%20elegant%20traditional%20costumes%2C%20cinematic%20composition%20with%20soft%20depth%20of%20field%2C%20dark%20rich%20background%2C%20premium%20entertainment%20visual&width=800&height=500&seq=cards-01&orientation=landscape',
  },
  {
    title: '科幻巨制 · 流浪地球系列',
    desc: '国产科幻巅峰之作，震撼视觉特效与感人故事并存。两部合集蓝光版现已上线天美麻花星空影视。',
    tag: '高分佳作',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20scene%20with%20a%20giant%20planet%20and%20spaceship%20in%20deep%20space%2C%20dramatic%20blue%20and%20gold%20cosmic%20lighting%2C%20cinematic%20epic%20scale%2C%20dark%20space%20background%20with%20stars%2C%20movie%20poster%20aesthetic&width=800&height=500&seq=cards-02&orientation=landscape',
  },
  {
    title: '韩剧精选 · 高分必看',
    desc: '精选豆瓣8.5分以上韩剧合集，爱情、悬疑、奇幻题材全覆盖。高清中文字幕，追剧首选。',
    tag: '精选合集',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20drama%20scene%20with%20soft%20cherry%20blossom%20and%20warm%20golden%20sunset%20lighting%2C%20elegant%20couple%20silhouette%2C%20cinematic%20composition%2C%20emotional%20and%20dreamy%20atmosphere%2C%20entertainment%20drama%20aesthetic&width=800&height=500&seq=cards-03&orientation=landscape',
  },
  {
    title: '综艺大赏 · 笑点密集',
    desc: '《极限挑战》《青春有你》《王牌对王牌》等热门综艺免费在线观看，每周更新不重样。',
    tag: '综艺专区',
    cover: 'https://readdy.ai/api/search-image?query=A%20vibrant%20variety%20show%20stage%20with%20colorful%20stage%20lighting%20and%20confetti%2C%20energetic%20performance%20atmosphere%2C%20warm%20spotlight%20beams%2C%20dynamic%20entertainment%20composition%2C%20dark%20theater%20background%2C%20joyful%20celebration%20mood&width=800&height=500&seq=cards-04&orientation=landscape',
  },
  {
    title: '动漫热血番 · 夏季新番',
    desc: '《鬼灭之刃 锻刀村篇》《咒术回战 第二季》等热门日漫高清在线，国漫专区同步热播。',
    tag: '新番连载',
    cover: 'https://readdy.ai/api/search-image?query=An%20action%20anime%20scene%20with%20dynamic%20fighting%20pose%20and%20flame%20effects%2C%20warm%20orange%20and%20gold%20fire%20lighting%2C%20stylized%20Japanese%20animation%20aesthetic%2C%20dark%20dramatic%20background%2C%20intense%20energy%20and%20motion&width=800&height=500&seq=cards-05&orientation=landscape',
  },
  {
    title: '纪录片 · 探索未知世界',
    desc: 'BBC、国家地理精选纪录片合集，自然、历史、科技、人文四大板块，超清画质沉浸式观看体验。',
    tag: '知识频道',
    cover: 'https://readdy.ai/api/search-image?query=A%20breathtaking%20nature%20documentary%20scene%20with%20vast%20mountain%20landscape%20and%20golden%20sunrise%20light%2C%20misty%20valley%20atmosphere%2C%20cinematic%20wide%20composition%2C%20rich%20natural%20color%20palette%2C%20premium%20documentary%20photography%20aesthetic&width=800&height=500&seq=cards-06&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-50">
            精选推荐
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
            编辑精选优质影视内容，为你发现更多好片
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {CARDS.map((card, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-300/15 hover:border-background-300/30 transition-all cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={card.cover}
                  alt={card.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  onError={(e) => {
                    (e.currentTarget as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-medium rounded-full bg-background-950/70 text-primary-400 border border-primary-500/20 whitespace-nowrap">
                    {card.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-100 group-hover:text-primary-400 transition-colors">
                  {card.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-3">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}